export default __webpack_public_path__ + "src/images/packages/clifftop-exclusive-safari/3165c730214d06f235c4b75072833360-5.jpeg";